$(document).ready(function () {
  $("ul#popups li a").click(function () {
    var href = $(this).attr("href");
    console.log(href);

    $(".additional-options div").removeClass("active").hide();

    $(href).addClass("active").show();

    $("ul#popups li a").removeClass("active");

    $(this).addClass("active");
  });

  $("span.fancybox-item.fancybox-close").click(function () {
    $(".popup_tabs").removeClass("active");
  });

  $("button.button_size_chart").click(function () {
    $(".pdp_size-chart").addClass("active");
    $("body").addClass("popup_open");
  });

  $(".pdp_size-chart .fancybox-close").click(function () {
    $(".pdp_size-chart").removeClass("active");
    $("body").removeClass("popup_open");
  });

  $(
    "body.template-suffix-myturnview fieldset.option-selector legend.label"
  ).each(function () {
    if ($(this).text() === "Size") {
      $(this).text("AVAILABLE SIZES");
    }
  });



  //    $('.custom_reverse .century_slider-wrapper').slick({
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   dots: false,
  //   speed: 300,
  //   infinite: true,
  //   autoplaySpeed: 2000,
  //   autoplay: true,
  //   prevArrow:
  //     '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0416/3169/files/left-arrow.svg?v=1740977169"></button>',
  //   nextArrow:
  //     '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0416/3169/files/right-arrow.svg?v=1740977168"></button>',
  //   responsive: [
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         slidesToShow: 1,
  //       },
  //     },
  //   ],
  // });



});

$('.text_with_slider.community_slider .slider_main-wrapper').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  speed: 300,
  infinite: true,
  autoplaySpeed: 2000,
  autoplay: true,
  prevArrow:
    '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0416/3169/files/left-arrow.svg?v=1740977169"></button>',
  nextArrow:
    '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0416/3169/files/right-arrow.svg?v=1740977168"></button>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(".first_size_value a").click(function (event) {
  event.preventDefault(); // Prevent the page from scrolling to the top

  var section = $(this).closest(".custom_size_chart"); // Find the closest section
  section.find(".first_size_value a").removeClass("active"); // Remove 'active' class from all first size values
  $(this).addClass("active"); // Add 'active' class to clicked element

  if ($(this).hasClass("inches_value")) {
    section.find(".measurement__Table td.inches_value").addClass("active");
    section.find(".measurement__Table td.cm_values").removeClass("active");
  } else {
    section.find(".measurement__Table td.cm_values").addClass("active");
    section.find(".measurement__Table td.inches_value").removeClass("active");
  }
});

$(".second_size_value a").click(function (event) {
  event.preventDefault(); // Prevent the page from scrolling to the top

  var section = $(this).closest(".custom_size_chart"); // Find the closest section
  section.find(".second_size_value a").removeClass("active"); // Remove 'active' class from all second size values
  $(this).addClass("active"); // Add 'active' class to clicked element

  if ($(this).hasClass("inches_value")) {
    section.find(".measurement_Table1 td.inches_value").addClass("active");
    section.find(".measurement_Table1 td.cm_values").removeClass("active");
  } else {
    section.find(".measurement_Table1 td.cm_values").addClass("active");
    section.find(".measurement_Table1 td.inches_value").removeClass("active");
  }
});

$(".training_apparel .first_size_value a").click(function (event) {
  event.preventDefault(); // Prevent the page from scrolling to the top

  var section = $(this).closest(".custom_size_chart"); // Find the closest section
  section.find(".first_size_value a").removeClass("active"); // Remove 'active' class from all first size values
  $(this).addClass("active"); // Add 'active' class to clicked element

  if ($(this).hasClass("inches_value")) {
    section.find(".measurement__Table td.inches_value").addClass("active");
    section.find(".measurement__Table td.cm_values").removeClass("active");
  } else {
    section.find(".measurement__Table td.cm_values").addClass("active");
    section.find(".measurement__Table td.inches_value").removeClass("active");
  }
});

$(".training_apparel .second_size_value a").click(function (event) {
  event.preventDefault(); // Prevent the page from scrolling to the top

  var section = $(this).closest(".custom_size_chart"); // Find the closest section
  section.find(".second_size_value a").removeClass("active"); // Remove 'active' class from all second size values
  $(this).addClass("active"); // Add 'active' class to clicked element

  if ($(this).hasClass("inches_value")) {
    section.find(".measurement_Table1 td.inches_value").addClass("active");
    section.find(".measurement_Table1 td.cm_values").removeClass("active");
  } else {
    section.find(".measurement_Table1 td.cm_values").addClass("active");
    section.find(".measurement_Table1 td.inches_value").removeClass("active");
  }
});

$('.text_with_slider .two_images_slider').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  speed: 300,
  infinite: true,
  autoplaySpeed: 2000,
  autoplay: true,
  prevArrow:
    '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0416/3169/files/left-arrow.svg?v=1740977169"></button>',
  nextArrow:
    '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0416/3169/files/right-arrow.svg?v=1740977168"></button>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});


    // Select all checkboxes
    const checkboxes = document.querySelectorAll('.goal-text-block input[type="checkbox"]');

    // Loop through each checkbox and add event listeners
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            // Add or remove class based on checkbox state
            if (this.checked) {
                this.parentElement.classList.add('checked'); // Add class 'checked' when checked
            } else {
                this.parentElement.classList.remove('checked'); // Remove class 'checked' when unchecked
            }
        });
    });




$(document).ready(function () {

  function updateButtonClass() {
    $('.add-to-cart').each(function () {
      const button = $(this);
      const text = button.text().trim();

      console.log('Button text:', text);

      if (text.includes('Notify Me When Available')) {
        button.addClass('restock-trigger-button');
        button.removeAttr('disabled');
      } else {
        button.removeClass('restock-trigger-button');
      }
    });
  }

  console.log('Running initial check');
  updateButtonClass();

  $('label.opt-label').on('click', function () {
    console.log('Variant label clicked');

    setTimeout(function () {
      console.log('Re-checking after variant change');
      updateButtonClass();
    }, 300);
  });

  // ✅ delegated event binding (IMPORTANT FIX)
  $(document).on('click', 'button.restock-trigger-button', function (event) {
    console.log('restock-trigger-button clicked');

    event.preventDefault();
    event.stopPropagation();

    $('.restock-rocket-button-cover').trigger('click');
  });

});    